import React, { useEffect, useState } from 'react';
import { FaTimes } from 'react-icons/fa';
import StoreGoogleBadge from '../../assets/images/home-figma/store-google.svg?react';
import StoreAppleBadge from '../../assets/images/home-figma/store-apple.svg?react';
import { APP_STORE_URLS, isStoreLinkReady } from '../../Utils/Constants/appStores';
import './DownloadAppSticky.css';

const STORAGE_KEY = 'dante_download_app_closed_at';
const REOPEN_AFTER_MS = 15 * 60 * 1000; // 15 minutes

const getShouldOpen = () => {
  try {
    const closedAt = Number(localStorage.getItem(STORAGE_KEY));
    if (!closedAt || Number.isNaN(closedAt)) return true;
    return Date.now() - closedAt >= REOPEN_AFTER_MS;
  } catch {
    return true;
  }
};

const DownloadAppSticky = () => {
  const [isOpen, setIsOpen] = useState(() => getShouldOpen());

  useEffect(() => {
    if (isOpen) return undefined;

    let closedAt = 0;
    try {
      closedAt = Number(localStorage.getItem(STORAGE_KEY)) || Date.now();
    } catch {
      closedAt = Date.now();
    }

    const remaining = Math.max(REOPEN_AFTER_MS - (Date.now() - closedAt), 0);
    const timer = window.setTimeout(() => {
      setIsOpen(true);
      try {
        localStorage.removeItem(STORAGE_KEY);
      } catch {
        // ignore
      }
    }, remaining);

    return () => window.clearTimeout(timer);
  }, [isOpen]);

  const handleClose = () => {
    setIsOpen(false);
    try {
      localStorage.setItem(STORAGE_KEY, String(Date.now()));
    } catch {
      // ignore
    }
  };

  const handleStoreClick = (event, url) => {
    if (!isStoreLinkReady(url)) {
      event.preventDefault();
    }
  };

  return (
    <div className={`download-app-sticky ${isOpen ? 'is-open' : ''}`}>
      {isOpen && (
        <div className="download-app-sticky__panel" role="dialog" aria-label="Download the app">
          <div className="download-app-sticky__panel-header">
            <h3>Download the App</h3>
            <button
              type="button"
              className="download-app-sticky__close"
              onClick={handleClose}
              aria-label="Close download panel"
            >
              <FaTimes />
            </button>
          </div>
          <p className="download-app-sticky__copy">
            Get Let&apos;s Plan a Date on your phone and stay connected on the go.
          </p>
          <div className="download-app-sticky__stores">
            <a
              href={APP_STORE_URLS.googlePlay}
              className="download-app-sticky__store-link"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Get it on Google Play"
              onClick={(e) => handleStoreClick(e, APP_STORE_URLS.googlePlay)}
            >
              <StoreGoogleBadge />
            </a>
            <a
              href={APP_STORE_URLS.appleAppStore}
              className="download-app-sticky__store-link download-app-sticky__store-link--apple"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Download on the App Store"
              onClick={(e) => handleStoreClick(e, APP_STORE_URLS.appleAppStore)}
            >
              <StoreAppleBadge />
            </a>
          </div>
        </div>
      )}

      {!isOpen && (
        <button
          type="button"
          className="download-app-sticky__fab"
          onClick={() => {
            setIsOpen(true);
            try {
              localStorage.removeItem(STORAGE_KEY);
            } catch {
              // ignore
            }
          }}
          aria-label="Open download app menu"
        >
          Get App
        </button>
      )}
    </div>
  );
};

export default DownloadAppSticky;
